<template>
  <div class="calendar-tasks">
    <div 
      v-for="tag in tags"
      :key="tag.name"
      @click="$emit('activeTag', tag.id)"
      class="mb-1 mr-3 mt-1 d-flex align-content-center align-items-center calendar-tasks-task"
    >
      <div :class="['task-tags', 'tags-rounded-icon', tag.active ? `${tag.class}` : 'task-tags-inactive', 'd-flex']"></div>
      <span class="text-secondary ml-2">{{ tag.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tags: {
      type: Object,
      default: () => {},
    },
  },
}
</script>